export const blockIconsHouseholdCheckroomNew = (
	<span className='material-symbols-outlined'>checkroom</span>
);
